import {LobbyHeaderTitleDefaultBox} from "./lobby-header-title.default.box";
import {LobbyHeaderTitleSIBox} from "./lobby-header-title.si.box";
import {LobbyHeaderTitleMrGreenBox} from "./lobby-header-title.mrgreen.box";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";
import {LobbyHeaderTitleCasino777Box} from "./lobby-header-title.casino777.box";
import {LobbyHeaderTitleCasino888Box} from "./lobby-header-title.casino888.box";

export const LobbyHeaderTitleBox = styledByTheme(LobbyHeaderTitleDefaultBox)
    .forCasino888(LobbyHeaderTitleCasino888Box)
    .forCasino777(LobbyHeaderTitleCasino777Box)
    .forSI(LobbyHeaderTitleSIBox)
    .forMrGreen(LobbyHeaderTitleMrGreenBox)
    .apply();